import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CreateExaminationPayload } from "@/api/rest/examinations/ExaminationsTypes";

export interface ExaminationFormState {
  examMode: string;
  sampleManufacturerName: string;
  sampleType: string;
  sampleName: string;
  sampleManufacturedDate: string;
  sampleSerialNumber: string;
  operator: string;
  notes: string;
}

const initialState: ExaminationFormState = {
  examMode: "",
  sampleManufacturerName: "",
  sampleType: "",
  sampleName: "",
  sampleManufacturedDate: new Date().toJSON().substring(0, 10),
  sampleSerialNumber: "",
  operator: "",
  notes: "",
};

export const examinationFormSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setExamMode: (state, action: PayloadAction<string>) => {
      state.examMode = action.payload;
    },
    setSampleManufacturerName: (state, action: PayloadAction<string>) => {
      state.sampleManufacturerName = action.payload;
    },
    setSampleType: (state, action: PayloadAction<string>) => {
      state.sampleType = action.payload;
    },
    setSampleName: (state, action: PayloadAction<string>) => {
      state.sampleName = action.payload;
    },
    setSampleManufacturedDate: (state, action: PayloadAction<string>) => {
      state.sampleManufacturedDate = action.payload;
    },
    setSampleSerialNumber: (state, action: PayloadAction<string>) => {
      state.sampleSerialNumber = action.payload;
    },
    setOperator: (state, action: PayloadAction<string>) => {
      state.operator = action.payload;
    },
    setNotes: (state, action: PayloadAction<string>) => {
      state.notes = action.payload;
    },
    fillExaminationFields: (
      state,
      action: PayloadAction<CreateExaminationPayload>
    ) => {
      Object.entries(action.payload).forEach(([key, value]) => {
        // @ts-ignore
        state[key] = value;
      });
    },
    clearExaminationForm: () => initialState,
  },
});

export const {
  setExamMode,
  setOperator,
  setSampleManufacturedDate,
  setSampleName,
  setSampleType,
  setSampleManufacturerName,
  setSampleSerialNumber,
  setNotes,
  fillExaminationFields,
  clearExaminationForm,
} = examinationFormSlice.actions;

export default examinationFormSlice.reducer;
